<template>
  <app-layout>
    <div v-loading.fullscreen="!project">
      <!-- <app-stepper
      :scaffold="scaffold"
      :project="project"
      :current="3"
    /> -->

      <div class="max-w-screen-xl mx-auto px-5">
        <div v-if="project && scaffold">
          <app-project-download-actions
            class="mt-5 mb-3"
          ></app-project-download-actions>

          <div class="mt-4 mb-4 border-2 border-gray-50">
            <h2
              class="flex justify-between items-center p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              Project Details
            </h2>

            <div class="m-4">
              <app-project-label-edit
                :project="project"
              ></app-project-label-edit>

              <div class="mt-2">
                Scaffold:
                <strong class="ml-1"
                  >{{ scaffold.name }} ({{
                    project.version
                  }})</strong
                >
              </div>

              <div
                v-if="
                  project.presenter &&
                    project.presenter.properties.length
                "
              >
                <div
                  class="mt-2"
                  v-for="property in project.presenter
                    .properties"
                  :key="property.label"
                >
                  {{ property.label }}:
                  <strong class="ml-1">{{
                    property.value
                  }}</strong>
                </div>
              </div>
              <div
                class="my-2"
                v-if="
                  project.presenter &&
                    project.presenter.entities.length
                "
              >
                <div>
                  Entities:
                  <el-tooltip
                    v-for="entity in project.presenter
                      .entities"
                    placement="top"
                    :key="entity.label"
                    :content="entity.value"
                    effect="light"
                  >
                    <el-tag
                      type="info"
                      size="mini"
                      class="ml-2"
                      >{{ entity.label }}</el-tag
                    >
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="files && files.length"
            class="mt-4 mb-4 border-2 border-gray-50"
          >
            <h2
              class="flex justify-between items-center p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
            >
              FILE BROWSER
            </h2>
            <app-project-file-explorer></app-project-file-explorer>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-project-download',

  props: ['projectId'],

  created() {
    if (!this.files || !this.files.length) {
      this.$router.push({
        name: 'project-preview',
        params: {
          projectId: this.projectId,
        },
      });
    }
  },

  computed: {
    ...mapGetters({
      files: 'project/files',
      project: 'project/project',
      scaffold: 'scaffold/current',
      currentUserUid: 'auth/currentUserUid',
    }),

    projectUserName() {
      if (
        this.currentUserUid &&
        this.currentUserUid === this.project.userId
      ) {
        return `${this.project.userName}`;
      }

      return this.project.userName;
    },
  },
};
</script>

<style></style>
